const courseSettings = {
  language: "en",
  name: "Programming for Digital Humanities",
  siteUrl: "https://rage.github.io/programming-digital-humanities/",
  githubUrl: "https://github.com/rage/programming-digital-humanities",
  subtitle: "Python Programming for the Digital Humanities",
  slug: "programming-for-dh-2026",
  organizationName: "MOOC",
  tmcCourse: "programming-for-dh-2026",
  quizzesId: "",
  tmcOrganization: "mooc",
  bannerPath: "banner.svg",
  showExerciseDescriptionWhenNotLoggedIn: true,
  courseVariants: [
    // {
    //   tmcOrganization: "hbc",
    //   tmcCourse: "python-TVT24Eng"
    // },
    // {
    //   tmcOrganization: "insviladegracia",
    //   tmcCourse: "python-viladegracia-2024"
    // },
    // {
    //   tmcOrganization: "hbc",
    //   tmcCourse: "python-TVT21A",
    //   // quizzesId: "5c89b9b6-b8a6-4079-8c4f-a4bbc80b66a4",
    // },
  ],
}

module.exports = courseSettings
